import { createContext, ReactNode, useEffect, useState } from 'react';

interface QuotaContextType {
  usage: number;
  total: number;
  updateUsage: (newValue: number) => void;
  setIsQuotaPopupVisible: (newValue: boolean) => void;
  isQuotaPopupVisible: boolean;
}

interface QuotaContextProviderProps {
  children: ReactNode;
}

const INITIAL_TOTAL_VALUE = 1000;

export const QuotaContext = createContext({} as QuotaContextType);

export function QuotaContextProvider({ children }: QuotaContextProviderProps) {
  const [total, setTotal] = useState(INITIAL_TOTAL_VALUE);
  const [usage, setUsage] = useState(0);

  const [isQuotaPopupVisible, setIsQuotaPopupVisible] = useState(false);

  useEffect(() => {
    if (usage >= total * (80 / 100)) {
      setIsQuotaPopupVisible(true);
    }
  }, [total, usage]);

  const updateUsage = (newValue: number) => {
    setUsage(newValue);
  };

  return (
    <QuotaContext.Provider
      value={{
        total,
        usage,
        updateUsage,
        isQuotaPopupVisible,
        setIsQuotaPopupVisible,
      }}
    >
      {children}
    </QuotaContext.Provider>
  );
}
